module.exports = "/_next/static/images/profile-eli-9c71fefa5df0cab373b8f74aad9aabdd.png";